export var reduxKey = '@@Mention';
//# sourceMappingURL=constants.js.map